import type { CircleLayer } from 'react-map-gl';

const StationStrokeLayer: CircleLayer = {
  id: "marker-stroke-layer",
  type: "circle",
  paint: {
    "circle-radius": [
      "interpolate", ["linear"], ["zoom"],
      0, 4,
      6, 4,
      10, 12
    ],
    "circle-opacity": 0,
    "circle-color": "transparent",
    "circle-stroke-color": "white",
    "circle-stroke-opacity": 0.5,
    "circle-stroke-width": [
      "interpolate", ["linear"], ["zoom"],
      0, 1,
      6, 1,
      10, 4
    ],      
  }
}

export { StationStrokeLayer }
